export interface Settings {
    block_id: string;
    error_message: string;
    form_section_title?: string;
    code?: string;
    password_requirements?: string[];
    password_length?: number;
    redirect_url: string;
    submit_button_text: string;
    email: string;
    errorMessage?: string;
}

export const defaultSettings: Settings = {
    block_id: '',
    error_message: 'Password must contain at least one uppercase letter, one lowercase letter, one digit, one special character, and be at least 8 characters long.',
    form_section_title: 'Update Password',
    code: '',
    password_requirements: ['uppercase', 'lowercase', 'number', 'special_character'],
    password_length: 8,
    redirect_url: '',
    submit_button_text: 'Update Password',
    email: '',
};
